import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";
import { Link, useNavigate, useParams } from "react-router-dom";
import DetailMenuOffcanvas from "../../../Components/Common/DetailMenuOffcanvas";
import Alert from "../../../Components/Common/Alert";
import { DEFAULT_PRODUCT_IMAGE } from "../../../constants/images";
import { useQueryParams } from "../../../helpers/helpers";
import { showAlertWithTimeout } from "../../../slices/Alert/reducer";
import { addDraftOrderItem, getShopMenu } from "../../../slices/thunks";
import { AppDispatch } from "../../../store";
import HeaderSidebarToggle from "../../../Components/Common/HeaderSidebarToggle";

const DraftOrderAddItem = () => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const { orderId } = useParams<{ orderId: string }>();
    const { shopMenu } = useSelector((state: any) => state.ShopMenu);
    const queryParam = useQueryParams();
    const shopSlug = queryParam.get("shopSlug") || "";

    useEffect(() => {
        dispatch(getShopMenu({ shopSlug }));
    }, [dispatch, shopSlug]);

    const [cateMenuTab, setcateMenuTab] = useState("0");
    const toggleCateMenuTab = (tab: string) => {
        if (cateMenuTab !== tab) {
            setcateMenuTab(tab);
        }
    };

    const [selectedProduct, setSelectedProduct] = useState<any>(null);
    const [showAddItemComplete, setShowAddItemComplete] = useState(false);
    const [latestDetail, setLatestDetail] = useState<any>(null);
    const [isSaving, setIsSaving] = useState(false);

    const handleSelectedProduct = (product: any) => {
        setSelectedProduct(product);
    };

    const handleCloseDetailMenu = () => {
        setSelectedProduct(null);
    };

    const handleSaveItem = async (item: any) => {
        if (!orderId || isSaving) {
            return;
        }
        setIsSaving(true);
        try {
            const result = await dispatch(addDraftOrderItem({ orderId, item })).unwrap();
            setLatestDetail(result.data);
            setShowAddItemComplete(true);
        } catch (error: any) {
            dispatch(
                showAlertWithTimeout(
                    "danger",
                    "Không thể thêm món",
                    error?.toString() || "Vui lòng thử lại sau",
                ),
            );
        } finally {
            setIsSaving(false);
        }
    };

    const handleReturnToOrder = () => {
        if (orderId) {
            navigate(`/order/${orderId}`, {
                state: latestDetail ? { draftOrderDetail: latestDetail } : undefined,
            });
        } else {
            navigate(-1);
        }
    };

    return (
        <React.Fragment>
            <Alert />
            <div className="position-relative mb-9">
                <div className="header-area" id="headerArea">
                    <div className="container h-100 d-flex text-center align-items-center justify-content-between rtl-flex-d-row-r">
                        <div className="back-button me-2">
                            <Link
                                to="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    navigate(-1);
                                }}
                            >
                                <i className="mdi mdi-arrow-left"></i>
                            </Link>
                        </div>

                        <div className="page-heading">
                            <h6 className="mb-0">Thêm món vào đơn</h6>
                        </div>

                        <HeaderSidebarToggle className="ms-2" />
                    </div>
                </div>
                <div className="page-content-wrapper">
                    <div className="container">
                        {selectedProduct && (
                            <DetailMenuOffcanvas
                                menuId={String(selectedProduct.id)}
                                isOpen={selectedProduct !== null}
                                onClose={handleCloseDetailMenu}
                                onSave={handleSaveItem}
                            />
                        )}
                        <div className="vendor-details-wrap bg-img bg-overlay py-4">
                            <div className="container">
                                <div className="d-flex align-items-start">
                                    <div className="vendor-profile shadow me-3">
                                        <figure className="m-0">
                                            <img src={shopMenu?.shop.image} alt="" />
                                        </figure>
                                    </div>
                                    <div className="vendor-info">
                                        <h6 className="mb-1 vendor-title text-white">{shopMenu?.shop.name}</h6>
                                        <p className="mb-1 text-white">
                                            <i className="mdi mdi-map-marker me-1"></i>
                                            {shopMenu?.shop.address}
                                        </p>
                                        <p className="mb-1 text-white">
                                            <i className="mdi mdi-phone me-1"></i>
                                            {shopMenu?.shop.phone}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {showAddItemComplete && (
                            <div className="alert alert-success d-flex align-items-center justify-content-between mt-3" role="alert">
                                <span className="me-3 mb-0">Đã thêm món vào đơn nháp.</span>
                                <div className="d-flex gap-2">
                                    <button
                                        type="button"
                                        className="btn btn-outline-success btn-sm"
                                        onClick={() => setShowAddItemComplete(false)}
                                    >
                                        Tiếp tục chọn
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-success btn-sm"
                                        onClick={handleReturnToOrder}
                                    >
                                        Về đơn hàng
                                    </button>
                                </div>
                            </div>
                        )}
                        <div className="tab-content mt-3">
                            <div className="container">
                                <Row>
                                    <Col xs={4} className="ps-0 pe-0 py-2">
                                        <Nav tabs className="nav nav-tabs nav-tabs-left nav-border-top nav-border-top-primary mb-3">
                                            {
                                                shopMenu?.categories && shopMenu.categories.map((item: any, index: number) => (
                                                    <NavItem key={index}>
                                                        <NavLink
                                                            className={classnames("cursor-pointer", { active: cateMenuTab === index.toString() })}
                                                            onClick={() => {
                                                                toggleCateMenuTab(index.toString());
                                                            }}
                                                        >
                                                            {item.name}
                                                        </NavLink>
                                                    </NavItem>
                                                ))
                                            }
                                        </Nav>
                                    </Col>
                                    <Col xs={8} className="ps-0 pe-0">
                                        <div className="container">
                                            <TabContent activeTab={cateMenuTab} className="text-muted">
                                                {
                                                    shopMenu?.categories && shopMenu.categories.map((item: any, index: number) => (
                                                        <TabPane tabId={index.toString()} key={index}>
                                                            <div className="row g-2 py-2 rtl-flex-d-row-r featured-product-card-custom">
                                                                {
                                                                    item?.menus && item.menus.map((product: any, productIndex: number) => (
                                                                        <div className="col-6" key={productIndex}>
                                                                            <div
                                                                                className="card product-card"
                                                                                onClick={() => handleSelectedProduct(product)}
                                                                            >
                                                                                <div className="card-body">
                                                                                    <div className="product-thumbnail-side">
                                                                                        <span className="product-thumbnail d-block">
                                                                                            <img
                                                                                                src={product.image || DEFAULT_PRODUCT_IMAGE}
                                                                                                alt=""
                                                                                            />
                                                                                        </span>
                                                                                    </div>
                                                                                    <div className="product-description">
                                                                                        <span className="product-title d-block">
                                                                                            {product.name}
                                                                                        </span>
                                                                                        <p className="sale-price">{product.price}đ</p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                }
                                                            </div>
                                                        </TabPane>
                                                    ))
                                                }
                                            </TabContent>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default DraftOrderAddItem;
